import { kebabCase } from 'lodash'

// Build a `urlKeys` map for `useQueryStates` by converting each parser key from camelCase to kebab-case (e.g. `startDate` -> `start-date`).
export function kebabCaseUrlKeys<T extends Record<string, unknown>>(
  parsers: T
): { [K in keyof T & string]: string } {
  const result = {} as { [K in keyof T & string]: string }
  for (const key of Object.keys(parsers) as (keyof T & string)[]) {
    result[key] = kebabCase(key)
  }
  return result
}
